import { forwardRef } from "react";
import styles from "./RadioOption.module.css";

interface RadioOptionProps {
  label: string;
  name: string;
  options: {
    value: string;
    label: string;
  }[];
  value?: string;
  onChange?: (value: string) => void;
}

const RadioOption = forwardRef<HTMLDivElement, RadioOptionProps>(
  ({ label, name, options, value, onChange }, ref) => {
    return (
      <div ref={ref} className={styles["radio-option-container"]}>
        <span className={styles.label}>{label}</span>
        <div className={styles["radio-group"]}>
          {options.map((option) => (
            <label key={option.value} className={styles["radio-options"]}>
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={(e) => onChange?.(e.target.value)}
                className={styles.input}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    );
  }
);

RadioOption.displayName = "RadioOption";

export default RadioOption;
